module.exports = __webpack_public_path__ + "static/header-ba3f86abd00353222e30963a3698fcb8.png";